// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3b47df81","160":"ec5c8d37","208":"1a99a90a","293":"d6ec125c","516":"ad054598","519":"9814b2e9","917":"0f55c9cd","946":"6f100e71"}[chunkId] + ".chunk.js";
};